import {ExperimentNames, LIST_DISPLAY_STRATEGY} from '@wix/wix-events-commons-statics'
import {ControllerFlowAPI} from '@wix/yoshi-flow-editor'
import {EMPTY_CATEGORY_FILTER} from '../../../../commons/constants/settings'
import settingsParams from '../../settingsParams'
import {State} from '../types/state'
import {getSelectedCategoryFilterIds, isCategoryMenuMode} from './categories'

export const getVeloCategoryId = (state: State) => state.dynamicVeloOverrides.categoryId

export const getDynamicCategoryIds = (state: State, flowAPI: ControllerFlowAPI) => {
  if (isVeloOverrideUsed(state)) {
    const override = getVeloCategoryId(state)
    return override ? [override] : []
  }

  if (isCategoryMenuMode(flowAPI.settings.get)) {
    return getSelectedCategoryFilterIds(flowAPI.settings.get)
  }

  const updatedDisplayListEventsPanelEnabled = flowAPI.experiments.enabled(
    ExperimentNames.UpdatedDisplayListEventsPanel,
  )

  const categoryDisplayStrategy =
    flowAPI.settings.get(settingsParams.listDisplayStrategy) === LIST_DISPLAY_STRATEGY.CATEGORY

  const categoryId = flowAPI.settings.get(settingsParams.categoryId) as string

  return categoryId === EMPTY_CATEGORY_FILTER || (updatedDisplayListEventsPanelEnabled && !categoryDisplayStrategy)
    ? null
    : [categoryId]
}

export const getDynamicCategoryId = (state: State, flowAPI: ControllerFlowAPI) => {
  const categoryIds = getDynamicCategoryIds(state, flowAPI)
  return categoryIds && categoryIds.length === 1 ? categoryIds[0] : null
}

export const isVeloOverrideUsed = (state: State) =>
  Boolean(Object.values(state.dynamicVeloOverrides).find(item => item !== null))
